import React from 'react';
import './PortfolioProjectsChartsDetailContent.scss';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { setCurrentIndicator } from '../../../redux/actions/currentIndicator';
import { useDispatch } from 'react-redux';

export const AverageLagFilter = ({ currentIndicator }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const color = 'rgba(102, 102, 102, 1)';
  const stateOptions = [
    { value: 'totalData', label: t('all'), color },
    { value: 'criticalProductsData', label: t('critical_products'), color },
    { value: 'activitiesData', label: t('activities'), color },
  ];
  const [optionValue, setOptionValue] = React.useState<any>(stateOptions[0]);

  const changeOption = data => {
    let newCenterText: string;

    if (data.value === 'totalData') {
      newCenterText = currentIndicator.data.centerTextTotal;
    } else if (data.value === 'criticalProductsData') {
      newCenterText = currentIndicator.data.centerTextProducts;
    } else {
      newCenterText = currentIndicator.data.centerTextActivities;
    }

    const newIndicator = {
      ...currentIndicator,
      data: { ...currentIndicator.data, circles: currentIndicator.data[data.value], centerText: newCenterText },
    };
    dispatch(setCurrentIndicator(newIndicator));
    setOptionValue(data);
  };

  return (
    <div className="select-container">
      <h5 className="label-filter-avg">{t('advance_according_to')}:</h5>
      <div className="select-side">
        <Select
          className="select-ibd"
          value={optionValue}
          label="Single select"
          options={stateOptions}
          components={{
            IndicatorSeparator: () => null,
          }}
          onChange={changeOption}
        />
      </div>
    </div>
  );
}